import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { user } from '@/mocks/data/general/user'

import { api } from '@/utils/constants'

import { User } from '@/types/user'
import { AddPrivateCardPayload } from '@/types/user/card'

export const addPrivateCard = http.post(
    `${process.env.REACT_APP_API_ADDRESS}/${api.account.konvives.ADD_PRIVATE_CARD}`,
    async ({ request }) => {
        const payload = await request.json()

        const payloadParsed = AddPrivateCardPayload.safeParse(payload)

        // Wrong data
        if (!payloadParsed.success) {
            return HttpResponse.json(undefined, {
                status: StatusCodes.NOT_FOUND,
            })
        }

        const userToReturn = {
            ...user,
            card_id: payloadParsed.data.private_card_number,
        }

        return HttpResponse.json<User>(userToReturn)
    },
)
